import React, { Component, Fragment } from 'react';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import { get, postWithHeadersResponse, putWithHeadersResponse } from '../../../server/actions';
import { ConfirmDialog } from '../../Misc/confirmDialog';
import { _addNotification, _addNotificationError } from '../../../server/util';


class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            districtUsers: [],
            settingsData: {
                confirmingOfficialEnabled: false,
                confirmingOfficialUserIds: []
            }
        }
        // Initialize state if needed
    };
    userInfo = getLoginDistrictInfo();
    componentWillMount = () => {
        this.props.changeShowHideSchoolFitler(false);
        this.getDistrictUsers();

    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getDistrictSettings();
    }
    getDistrictSettings = () => {
        get(`/district-config/${this.userInfo.districtId}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                settingsData: {
                    "districtId": data.districtId,
                    "confirmingOfficialEnabled": data.confirmingOfficialEnabled,
                    "confirmingOfficialUserIds": data.confirmingOfficialUserIds
                },
                loading: false
            })
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('Get Users data response', error)
            }
        );

    }
    getDistrictUsers = () => {
        get(`/districts/${this.userInfo.districtId}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                districtUsers: (data.districtUsers || []).map(user => {
                    return ({ ...user, fullName: `${user.lastName} ${user.firstName}` })
                }),
                loading: false
            })
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('Get Users data response', error)
            }
        );

    }
    onChangeEnableConfirmingOfficial = (e) => {
        const { settingsData } = this.state;
        settingsData.confirmingOfficialEnabled = e.target.value === 'true' ? true : false;
        this.setState({ settingsData });
    }
    onAddConfirmingOfficial = () => {
        const { settingsData, selectedConfirmingOfficialId } = this.state;
        if (selectedConfirmingOfficialId) {
            if (!settingsData.confirmingOfficialUserIds.includes(selectedConfirmingOfficialId)) {
                settingsData.confirmingOfficialUserIds.push(selectedConfirmingOfficialId);
            }
            this.setState({ settingsData, selectedConfirmingOfficialId: '' });
        }
    }
    onChangeConfirmingOfficial = (e) => {
        this.setState({ selectedConfirmingOfficialId: e.target.value });
    }
    onRemoveConfirmingOfficial = (userId) => {
        const { settingsData } = this.state;
        ConfirmDialog('_dialog1',
            'Confirmation Alert',
            'Are you sure you want to remove this confirming official?', 'Ok', 'Cancel', (res) => {
                if (res) {
                    if (settingsData.confirmingOfficialUserIds.includes(userId)) {
                        const res = settingsData.confirmingOfficialUserIds.filter(id => id != userId);
                        settingsData.confirmingOfficialUserIds = res;
                        this.setState({ settingsData });
                    }
                }
            });
    }
    onSubmitSettings = () => {
        const { settingsData } = this.state;
        this.setState({ loading: true });
        let url = ``;
        const header = { 'Content-Type': 'application/json' };
        if (settingsData.id > 0) {
            url = `/district-config?access_token=`;
            postWithHeadersResponse(url, JSON.stringify(settingsData), header).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({ loading: false });
                _addNotification(data.statusMessage, this);
                console.log(data);
            }).catch(
                (error) => {
                    this.setState({ loading: false });
                    _addNotificationError('Error while saving settings. Please try again later.', this);
                    console.log('Get Users data response', error)
                }
            );

        } else {
            url = `/district-config/update/${this.userInfo.districtId}?access_token=`;
            putWithHeadersResponse(url, JSON.stringify(settingsData), header).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({ loading: false });
                _addNotification(`Settings saved successfully.`, this);
                console.log(data);
            }).catch(
                (error) => {
                    this.setState({ loading: false });
                    _addNotificationError('Error while saving settings. Please try again later.', this);
                    console.log('Get Users data response', error)
                });

        }
    }
    onCancelSettings = () => {
        this.context.router.history.push(`/district/dashboard`);
    }

    render() {
        const { loading, settingsData, selectedConfirmingOfficialId, districtUsers } = this.state;
        return (
            <section className="full-width clearfix">
                <div className="container">
                    <NotificationSystem ref="notificationSystem" />
                    <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={loading}
                        />
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                            <h2><span>Settings</span></h2>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6' >
                            <div style={{
                                border: 'solid 1px #ddd',
                                borderRadius: '3px',
                                padding: '5px'
                            }}>
                                <div className="row">
                                    <label className="col-sm-6" style={{ paddingTop: '5px' }} htmlFor="confirmingOfficialEnabled">Enable Confirming Official?</label>
                                    <div className="col-sm-2">
                                        <select className="form-control form-control-sm" id="confirmingOfficialEnabled" value={settingsData.confirmingOfficialEnabled}
                                            onChange={this.onChangeEnableConfirmingOfficial}>
                                            <option value={true}>Yes</option>
                                            <option value={false}>No</option>
                                        </select>
                                    </div>
                                </div>
                                {
                                    settingsData.confirmingOfficialEnabled && <Fragment>
                                        <div className='row'>
                                            <div className='col-md-12'>

                                                {
                                                    settingsData.confirmingOfficialUserIds.length > 0 ? <div style={{
                                                        height: '150px',

                                                    }}>
                                                        Confirming Officials: <br />
                                                        {
                                                            settingsData.confirmingOfficialUserIds.map((userId) => {
                                                                const usr = districtUsers.find(user => user.displayRecId == userId);
                                                                return (
                                                                    <span className='badge' style={{ fontSize: '14px', margin: '3px' }} key={userId}>
                                                                        <span> {(usr || {}).fullName || ''}</span>&nbsp; &nbsp; &nbsp;
                                                                        <span role='button' onClick={() => this.onRemoveConfirmingOfficial(userId)}>
                                                                            <i className="fa fa-times-circle-o" aria-hidden="true"></i>
                                                                        </span>
                                                                    </span>
                                                                )
                                                            })
                                                        }
                                                    </div> : <div style={{
                                                        height: '100px', display: 'flex',
                                                        justifyContent: 'center', alignItems: 'center'
                                                    }}>
                                                        No Confirming Official added yet.
                                                    </div>


                                                }

                                            </div>
                                        </div>

                                        <div className='row'>
                                            <label className='col-md-12'>Select Confirming Officials:</label>
                                            <div className='col-md-9'>
                                                <select className='form-control form-control-sm' value={selectedConfirmingOfficialId} onChange={this.onChangeConfirmingOfficial}>
                                                    <option value=''>Select User</option>
                                                    {
                                                        districtUsers.map((user) => (
                                                            <option key={user.displayRecId} value={user.displayRecId}>{user.fullName}</option>
                                                        ))
                                                    }

                                                </select>
                                            </div>
                                            <div className='col-md-3'>
                                                <button style={{ margin: '0px' }} className='btn btn-primary btn-sm'
                                                    onClick={this.onAddConfirmingOfficial}>Add</button>
                                            </div>
                                        </div>

                                    </Fragment>
                                }


                            </div>

                        </div>
                    </div>
                    <div className='row' style={{ marginTop: '10px' }}>
                        <div className='col-md-6'>

                            <button style={{ margin: '0px' }} className='btn btn-success btn-sm pull-right'
                                onClick={this.onSubmitSettings}>Save Settings</button>
                            <button style={{ margin: '0px', marginRight: '10px' }} className='btn btn-danger btn-sm pull-right'
                                onClick={this.onCancelSettings}>Cancel</button>
                        </div>
                    </div>

                </div>

            </section>
        );
    }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/components/District/Settings/index.jsx